<div class="container-fluid">
  <div class="row">
    <div class="col-10">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Payment Entry (Purchase)</h4>
      </div>
    </div>
    <div class="col-2">
    </div>
  </div>
<br>
 
   <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform"> 

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-md-5">
                <div class="form-group">
                  <label for="AccCode">Customer Name</label>
                  <ng-select formControlName="AccCode" name="AccCode" id="AccCode"
                (change)="getPendingInvoiceList()"    [items]="SupplierList"  bindLabel="AccName" bindValue="Amid" 
                    [(ngModel)]="selectedAccID"></ng-select>
                  <div class="invalidValidate" *ngIf="checkSupplier()">
                    Please provide Customer
                  </div>
                </div>

              </div>
              

              <div class="col-md-3">
                <div class="form-group">
                  <label for="DocNo">Voucher No</label>
                  <input class="form-control" formControlName="DocNo" id="DocNo"
                 disabled readonly   [ngClass]="{'is-invalid': submit && form.DocNo.errors}">
                  <div *ngIf="submit && form.DocNo.errors" class="invalid-feedback">
                    Please provide Voucher No
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="DocDate">Payment Date</label>
                  <input type="date" class="form-control" formControlName="DocDate"
                   id="DocDate"
                    [ngClass]="{'is-invalid': submit && form.DocDate.errors}">
                  <div *ngIf="submit && form.DocDate.errors" class="invalid-feedback">
                    Please provide Payment Date
                  </div>  
                </div>
              </div>
            </div>
                  <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="MasterRemarks">Remarks</label>
                  <input type="text" class="form-control" formControlName="MasterRemarks" id="MasterRemarks">
                </div>
              </div>
            </div> -->
              
            
          </div>
        </div>
        <!-- end card -->
      </div> <!-- end col -->


    </div>
   </form>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Payment Detail</h4>

            <div class="table-responsive">
              <table class="table table-hover mb-0" style="min-height:300px !important ;">

                <thead>
                  <tr class="TableHeaderRow">
                    <th>#</th>
                    <th>Commercial Invoice No</th>
                    <th>Commercial Invoice Date</th>
                    <th>Balance Amount</th>
                    <th style="min-width:250px!important">Payment Mode</th>
                    <th>Paid Amount</th>
                    <th style="min-width:250px!important">Remarks</th>
                    <!-- <th>Action</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of pendingInvoiceList;let i=index">
                    <th scope="row">{{i+1}}</th>
                    <td>{{item.PackingNo}}</td>
                    <td>{{item.PackingDate}}</td>
                    <td>{{item.PenAmount}}</td>
                    <td>
                      <ng-select name="PaymentMode" id="PaymentMode + {{item.SLCIId}}"
                      [items]="PaymentTypes"  bindLabel="Name" bindValue="Name" 
                      [(ngModel)]="item.PaymentMode"></ng-select>
                      </td>
                    <td>
                      <input type="number" class="form-control" id="RecAmount + {{item.SLCIId}}" value="0"
                      [(ngModel)]="item.RecAmount"></td>
                      <td>
                        <input class="form-control" id="Remarks + {{item.SLCIId}}" value=""
                        [(ngModel)]="item.Remarks"></td>
                      <!-- <td>
                      <button type="button" class="mdi mdi-18px mdi-delete text-danger"
                        (click)="DeletePrdItem(item,i)"></button>
                    </td> -->
                  </tr>
                  <tr class="TotalRow">
                    <td></td>
                    <td>Total</td>
                    <td></td>
                    <td>{{grandTotal.PenAmount}}</td>
                    <td></td>
                    <td>{{grandTotal.RecAmount}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>


    </div>

 
  
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-md-8">
                <div class="form-group">
                  <!-- <label for="PaymentTerms">Remarks</label>
                  <textarea rows="4" class="form-control" formControlName="PaymentTerms" id="PaymentTerms"></textarea> -->
                </div>
              </div>
              
                <div class="col-lg-2">
                </div>
                  <div class="col-lg-2">
                  <br>
                  <div class="card">
                    <button class="btn btn-primary " (click)="validSubmit()">Save</button>
                </div>
              </div>
        

            </div>
            </div>
      
            
            
        </div>
        <!-- end card -->
      </div> <!-- end col -->


    </div>
    <!-- end row -->

  <!-- </form> -->


</div>